module.exports = __webpack_public_path__ + "static/media/pdc-logo-small-info.3be806f0.svg";